import React, { Component } from 'react'

/* Components */
import ConfrontationRotationView from './ConfrontationRotationView';

// Modules
import { getChamp } from '../../utils/champsFunctions';
import { getCompetitorsFromChamp, getTeams } from '../../utils/competitorsFunctions';

class ConfrontationRotation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            loadingRotationList: true,
            rotationList: [],

            rotationId: null,
            isScoreMan: true,
        }
    }

    componentWillMount = async () => {
        let arrayOfRoute = this.props.location.pathname.split('/')

        // Get specific champ object
        const champId = arrayOfRoute[3];
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
            champId,
        });

        // Get list of rotation
        let localArrayOfRotations = []
        for (let i = 0; i < 20; i++) {
            localArrayOfRotations.push(i)
        }
        this.setState({
            rotationList: localArrayOfRotations,
            loadingRotationList: false
        })

        /* Get all competitors */
        let localArrayOfCompetitors = await getCompetitorsFromChamp(champId);
        sessionStorage.setItem('rotationArrayOfCompetitors', JSON.stringify(localArrayOfCompetitors))

        /* Get all teams */
        let localArray = await getTeams();
        sessionStorage.setItem('rotationArrayOfTeams', JSON.stringify(localArray));

        // Check if user came from scoreboard
        if (this.props.location.state && this.props.location.state.switchingId) {
            this.chooseSwitching(this.props.location.state.switchingId)
        }
    }

    chooseSwitching = (value) => {
        this.setState({
            rotationId: value
        })
    }

    render() {
        return (
            <ConfrontationRotationView
                champObject={this.state.champObject}
                champId={this.state.champId}

                loadingRotationList={this.state.loadingRotationList}
                rotationList={this.state.rotationList}
                chooseSwitching={e => this.chooseSwitching(e)}

                rotationId={this.state.rotationId}
                isScoreMan={this.state.isScoreMan}
            />
        )
    }
}

export default ConfrontationRotation